import { render, staticRenderFns } from "./SwitchClose.vue?vue&type=template&id=7dec252c&scoped=true&lang=pug"
import script from "./SwitchClose.vue?vue&type=script&lang=js"
export * from "./SwitchClose.vue?vue&type=script&lang=js"
import style0 from "./SwitchClose.vue?vue&type=style&index=0&id=7dec252c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec252c",
  null
  
)

export default component.exports